import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";
import { formatLength } from "../../../../constants";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import { interactionsContainerStyles } from "./styles";

const QTDetailsInteractionsFieldsSection = ({
  quicktaleDetails,
  setQuicktaleDetails,
}) => {
  return (
    <Grid container style={interactionsContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*# of likes section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Likes"}
          value={
            quicktaleDetails?.likedBy ? quicktaleDetails?.likedBy?.length : 0
          }
          disabled={true}
        />
        {/*# of Reactions section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Reactions"}
          value={
            quicktaleDetails?.reactions
              ? quicktaleDetails?.reactions?.length
              : 0
          }
          disabled={true}
        />
        {/*Modified Status Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Status Change Date"}
          // label={"Modified Status Date"}
          value={
            quicktaleDetails?.approvalStatus?.updatedAt &&
            moment
              .unix(quicktaleDetails?.approvalStatus?.updatedAt.seconds)
              .format("MM-DD-YYYY HH:mm:ss")
          }
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*# of Saves section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Saves"}
          value={quicktaleDetails?.noOfSaves ? quicktaleDetails?.noOfSaves : 0}
          disabled={true}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              noOfSaves: e.target.value,
            })
          }
        />
        {/*# of Shares section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Shares"}
          value={
            quicktaleDetails?.sharedWithUsers
              ? quicktaleDetails?.sharedWithUsers?.length
              : 0
          }
          disabled={true}
        />
        {/*Length section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Length"}
          value={
            quicktaleDetails.audioLength &&
            formatLength(quicktaleDetails.audioLength)
          }
          disabled={true}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              audioLength: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );
};

export default QTDetailsInteractionsFieldsSection;

